<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    item-text="nome"
    item-value="id"
    label="Usuário"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @change="onChange"
    v-bind="$attrs"
  >
    <template v-slot:append-outer>
      <slot name="append-outer"/>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import CompradorService from '@/api/comprador-service';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Object,
    roles: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
  },
  methods: {
    buildQuery(val) {
      let query = `(nome like "%${(val || '').toLowerCase()}%")`;

      if (this.roles && this.roles.length) {
        query += ` and role in ('${this.roles.join(',')}')`;
      }

      return query;
    },
    searchData(val) {
      const isSelected = this.localValue && this.localValue.descricao === val;

      const searchValue = isSelected || !val ? '' : val;

      this.loading = true;

      CompradorService.getUsuarios({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: this.buildQuery(searchValue),
      })
        .then((response) => {
          this.items = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onChange(event) {
      this.$emit('change', event);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchData, 1000);
    if (this.value) {
      this.items = [this.value];
    }
  },
};
</script>
